import { Component, h, Host, Listen } from '@stencil/core';
import { addStyleSettings } from '../../utils/custom-style';
import { customer } from '../../store/customer.store';
import { closeAccountFlow } from '../../modals/account.modal';


@Component({
  tag: 'tambr-account',
  styleUrl: 'tambr-account.css',
  shadow: true,
})
export class TambrAccount {

  @Listen('tambrAuthClose') tambrAuthClose() { 
    closeAccountFlow();
  }

  overlayClicked( ev: UIEvent ) {
    const targets = ev.composedPath() as EventTarget[];
    if ( targets[0] instanceof Element && targets[0].id === 'tambr-overlay' ) {
      closeAccountFlow();
    }
  }

  render() {
    return (
      <Host style={ addStyleSettings() }>
        <div class='tambr-overlay' id='tambr-overlay'
          onClick={ (event: UIEvent) => this.overlayClicked(event) }>
            { this.renderAccount() }
        </div>
      </Host>
    )
  }

  renderAccount() {
    if ( !customer.user ) {
      return ( <tambr-auth /> );
    } 

    else if ( customer.signUpProcessLoading || customer.platformCustomerLoading || customer.businessCustomerLoading ) {
      return ( <tambr-loading-spinner /> );
    }

    else if ( !customer.platformCustomer || !customer.businessCustomer ) {
      return ( <tambr-auth-complete /> );
    } 
    
    else if ( customer.platformCustomer && customer.businessCustomer ) {
      return ( <tambr-account-modal /> );
    } 
  }

}
